import React from 'react';
import Form from 'js/components/common/Form';
import { identity } from 'ramda';
import buildClassName from 'js/utils/classNameBuilder.util';

import { TableFilter } from '../TableFilter';
import { TableContentFragment } from '../TableContentFragment';
import { TableAnotherPeriodFilter } from '../TableAnotherPeriodFilter';

import style from './TableHeader.scss';

export const TableHeader = (props) => {
    const {
        validate,
        classNames,
        filters = [],
        initialValues,
        validationConfig,
        anotherPeriodFilter,
        onAnotherPeriodApply,
        afterFiltersControls = []
    } = props;
    const filtersMock = [...filters, ...Array(3)];

    filtersMock.length = 3;

    return (
        <Form
            validate={validate}
            initialValues={initialValues}
            onSubmit={anotherPeriodFilter && onAnotherPeriodApply || identity}
            validationConfig={validationConfig}
            render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className={`${buildClassName(['tableHeaderContainer'], style, classNames)} cms-table-header`}>
                    <div className={buildClassName(['filtersContainer'], style, classNames)}>
                        <div className={buildClassName(['filters'], style, classNames)}>
                            {filtersMock.map((filter, index) => filter
                                ? (
                                    <TableFilter
                                        {...filter}
                                        key={filter.id}
                                        className={`${buildClassName(['filter'], style, classNames)} ${filter.className || ''} cms-table-filter-${filter.name}`}
                                    />
                                )
                                : <div key={`${index}_${index}`} className={buildClassName(['filter'], style, classNames)} />
                            )}
                        </div>
                        {anotherPeriodFilter
                            ? (
                                <TableAnotherPeriodFilter
                                    {...anotherPeriodFilter}
                                    classNames={{ ...classNames, filter: style.filter }}
                                />
                            )
                            : null
                        }
                    </div>
                    {afterFiltersControls.length
                        ? (
                            <div className={`${buildClassName(['afterFiltersControlsContainer'], style, classNames)} cms-table-after-filters-controls`}>
                                {afterFiltersControls.map(control => (
                                    <TableContentFragment
                                        id={control.id}
                                        key={control.id}
                                        content={control.content}
                                    />
                                ))}
                            </div>
                        )
                        : null
                    }
                </form>
            )}
        />
    );
};
